import cn from 'classnames';
import type { ChangeEvent } from 'react';
import { useRef } from 'react';

type CheckboxProps = {
  label:string,
  onToggle:(e:ChangeEvent<HTMLInputElement>) => void,
  checked?: boolean
};
export const Checkbox:React.FC<CheckboxProps> = ({ label, onToggle, checked }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = (e:ChangeEvent<HTMLInputElement>) => {
    onToggle(e);
  };

  return (
    <label className="hover:bg-input relative flex cursor-pointer items-center rounded-b-sm border-b border-b-[#DFEBF1] p-5 pl-8">
      {checked &&
        <span className="bg-btn-gradient-green absolute left-0 top-1/2 h-8 w-1 -translate-y-1/2 rounded-lg" />
      }
      <input
        ref={inputRef}
        type="checkbox"
        defaultChecked={checked}
        onChange={onChange}
        className={cn(
          'relative h-4 w-4 rounded before:inline-block before:h-full before:w-full before:cursor-pointer before:content-[""]',
          { 'accent-style before:hidden': !checked },
        )}
      />
      <span className='ml-4'>{label}</span>
    </label>
  );
};